<template>
  <a-card size="small" title="筛选条件">
    <a-form-model :label-col="labelCol" class="search-form" label-align="left">
      <a-row :gutter="24">
        <a-col :span="6">
          <a-form-model-item label="迭代">
            <a-select v-model="filterForm.version_id" allow-clear placeholder="迭代" @change="onVersionChange">
              <a-select-option v-for="version in versions" :key="version.id" :value="version.id">{{ version.title }} </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="6">
          <a-form-model-item label="团队">
            <a-select v-model="filterForm.team" allow-clear placeholder="团队" @change="onTeamChange">
              <a-select-option v-for="team in teams" :key="team.id" :value="team.id">{{ team.name }} </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-button type="primary" @click="onSearch"> 搜索 </a-button>
      </a-row>
    </a-form-model>
  </a-card>
</template>

<script>
import { versionList } from '@/api/project/version';
import { teamList } from '@/api/system/team';

export default {
  name: 'VersionTaskFilter',
  props: {
    filterForm: {
      type: Object,
      default: {
        version_id: 1,
        user_group: 1
      }
    }
  },
  data() {
    return {
      labelCol: { span: 6 },
      wrapperCol: {},
      checkAll: true,
      indeterminate: false,
      plainOptions: [],
      versions: [],
      teams: [],
      result: null
    };
  },
  mounted() {
    this.getVersionList();
    this.getTeamList();
    // this.getDiagramData();
  },
  methods: {
    onVersionChange(value) {
      this.filterForm.version_id = value;
    },
    onTeamChange(value) {
      this.filterForm.user_group = value;
    },
    onSearch() {
      this.$emit('change');
    },

    // 获取项目列表
    getVersionList() {
      versionList({ project_id: 1 }).then(res => {
        this.versions = res.data.list;
      });
    },
    getTeamList() {
      teamList({}).then(res => {
        this.teams = res.data.items;
      });
    }
  }
};
</script>

<style lang="less" scoped>
.ant-form-item {
  margin-bottom: 0px;
  border-bottom: silver 1px dashed;
}
</style>
